import { render, staticRenderFns } from "./isRx.vue?vue&type=template&id=674973bf&scoped=true"
import script from "./isRx.vue?vue&type=script&lang=js"
export * from "./isRx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674973bf",
  null
  
)

export default component.exports